import React, { useState } from 'react';
import AuthorFilterModal from 'src/common/layouts/modal/AuthorFilterModal';
import { ReactComponent as Filter } from 'src/assets/filter.svg';
import { ReactComponent as Close } from 'src/assets/close.svg';

export interface SelectedFilters {
    array: string[];
    genre: string[];
    textType: string[];
}

interface Props {
    onFilterChange: (filters: SelectedFilters) => void;
    initialFilters?: SelectedFilters;
}

const AuthorFilterContainer: React.FC<Props> = ({ onFilterChange, initialFilters }) => {
    const [selectedFilters, setSelectedFilters] = useState<SelectedFilters>(
        initialFilters || { array: [], genre: [], textType: [] }
    );
    const [showModal, setShowModal] = useState(false);

    const handleConfirm = (filters: SelectedFilters) => {
        setSelectedFilters(filters);
        onFilterChange(filters);
        setShowModal(false);
    };

    const removeFilter = (filter: string) => {
        setSelectedFilters(prev => {
            const updated = {
                array: prev.array.filter(i => i !== filter),
                genre: prev.genre.filter(i => i !== filter),
                textType: prev.textType.filter(i => i !== filter),
            };
            onFilterChange(updated);
            return updated;
        });
    };

    const resetFilters = () => {
        const empty = { array: [], genre: [], textType: [] };
        setSelectedFilters(empty);
        onFilterChange(empty);
    };

    const allFilters = [
        ...selectedFilters.array,
        ...selectedFilters.genre,
        ...selectedFilters.textType,
    ];

    return (
        <div className="flex flex-row items-center gap-2 flex-wrap">
            {/* 필터 버튼 */}
            <button
                onClick={() => setShowModal(true)}
                className="flex items-center gap-1.5 bg-white border border-[#e0e0e0] rounded-full px-3.5 h-8 text-[13px] font-semibold text-[#555] hover:border-[#19cf7a] hover:text-[#19cf7a] transition-colors shadow-sm"
            >
                <Filter className="w-3.5 h-3.5" />
                필터
            </button>

            {/* 전체 뱃지 (필터 없을 때) */}
            {allFilters.length === 0 && (
                <span className="flex items-center bg-[#19cf7a] text-white text-[12px] font-semibold px-3.5 h-8 rounded-full">
                    전체
                </span>
            )}

            {/* 선택된 필터 칩 */}
            {allFilters.map((filter, idx) => (
                <span
                    key={idx}
                    className="flex items-center gap-1 bg-[#e8f8f0] text-[#19cf7a] text-[12px] font-semibold px-3 h-8 rounded-full border border-[#baecd4]"
                >
                    {filter}
                    <button
                        onClick={() => removeFilter(filter)}
                        className="text-[#19cf7a] hover:text-[#00a85a] transition-colors ml-0.5"
                    >
                        <Close className="w-3 h-3" />
                    </button>
                </span>
            ))}

            {/* 초기화 버튼 */}
            {allFilters.length > 0 && (
                <button
                    onClick={resetFilters}
                    className="text-[#bbb] text-[12px] hover:text-[#555] transition-colors ml-1 underline underline-offset-2"
                >
                    초기화
                </button>
            )}

            {showModal && (
                <AuthorFilterModal
                    key={JSON.stringify(selectedFilters)}
                    title="필터"
                    onClose={() => setShowModal(false)}
                    onConfirm={handleConfirm}
                    initialFilters={selectedFilters}
                />
            )}
        </div>
    );
};

export default AuthorFilterContainer;
